/**
 * Footer mobile accordion behaviour.
 * See specs/009-redesign-footer/
 */

export function initFooter() {
  const footer = document.querySelector('.footer');
  if (!footer || footer.dataset.footerAccordionBound === 'true') {
    return;
  }

  footer.dataset.footerAccordionBound = 'true';

  footer.addEventListener('click', (event) => {
    const toggle = event.target.closest('.footer-accordion__toggle');
    if (!toggle) {
      return;
    }

    const item = toggle.closest('.footer-accordion__item');
    if (!item) {
      return;
    }

    event.preventDefault();

    const isOpen = item.classList.contains('footer-accordion__item--open');
    item.classList.toggle('footer-accordion__item--open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
}
